import styled from "styled-components";
import { useEffect, useState, useContext } from "react";
import { useMyContext } from "@/app/utils/MyContext";
import BasicInfo from "../components/BasicInfo/BasicInfo";
import RaceCardPerformance from "@/app/ui/Common/RaceCardPerformance";
import Collapse from "@mui/material/Collapse";
import FullFormM from "@/app/ui/RaceDetail/components/RaceCard/FullFormM";
import { useLanguage } from "@/app/utils/LanguageContext";
import { text_size } from "@/app/utils/MixinSize";

const Container = styled.div`
  width: 100%;
  padding: 0px 2.13vw;
  position: relative;
  z-index: 1;
`;
const Content = styled.div`
  border-radius: 1.06vw 1.06vw 0 0;
  .mPerformance {
    padding-top: 0;
  }
`;
const MItemBottom = styled.div`
  padding: 8px 8px 12px;
  margin-top: 8px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px 4px 0 0;
`;
const LeftBtn = styled.div`
  line-height: 28px;
  border-radius: 30px;
  margin-right: 6px;
  background-color: rgba(226, 237, 246, 1);
  box-shadow: 0px 2px 4px 0px rgba(212, 212, 212, 0.5);
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 1);
  }
  &:active {
    p {
      color: white;
    }
    background-color: rgba(23, 62, 150, 1);
  }
  &.selected {
    p {
      color: white;
    }
    background-color: rgba(23, 62, 150, 1);
  }
`;
const RightBtn = styled.div`
  flex-basis: 60%;
  line-height: 28px;
  border-radius: 30px;
  background-color: rgba(226, 237, 246, 1);
  box-shadow: 0px 2px 4px 0px rgba(212, 212, 212, 0.5);
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 1);
  }
  &:active {
    p {
      color: white;
    }
    background-color: rgba(23, 62, 150, 1);
  }
  &.selected {
    p {
      color: white;
    }
    background-color: rgba(23, 62, 150, 1);
  }
`;
const DivBackgrounImage = styled('div')<{ $assetPrefix: string }>(({ $assetPrefix }) => `
  height: 250px;
  position: absolute;
  z-index: 0;
  top: 0;
  width: 100%; 
  background-image: url(${$assetPrefix}/HorseInfo_Banner_mobile.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left center;
  img{  
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left center;
  }
`);
const DivMobileHeader = styled.div`
  display: flex;
  width: 100%;
  height: 48px;
  line-height: 48px;
  background: linear-gradient(180deg, #012c60 0%, #01336f 100%);
  position: relative;
  z-index: 1;
`;
const DivMobileHeaderBack = styled.div`
  width: 84px;
  div {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  padding: 0 0 0 8px;
  display: flex;
  align-items: center;
`;
const DivMobileHeaderTitle = styled.div`
  display: flex;
  width: 100%;
  color: #ffffff;
  ${text_size(18)}
  font-weight: 700;
  text-align: center;
  justify-content: center;
`;

type propType = {
  data: any;
  meetingDate: string;
  meetingVenueCode: string;
  raceNo: number;
  horseNo: number;
  simulcastHorseId: any;
  gearData: any;
  raceCountry: any;
  horseStatus: any;
  totalRun: number
};
const HorseProfile: React.FC<propType> = (props) => {
  const { state: lang } = useLanguage();
  const { t } = lang;
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const [selectedTabM, setSelectedTabM] = useState("fullForm");
  const handleSelectPerformance = (race: any, type: any) => {
    setSelectedTabM(type);
  };
  return (
    <>
      <DivBackgrounImage $assetPrefix={myContextState.assetPrefix}>
        {/* <img src={`${myContextState.assetPrefix}/HorseInfo_Banner_mobile.png`}></img> */}
      </DivBackgrounImage>
      <DivMobileHeader>
        {/* <DivMobileHeaderBack>
          <div>
            <img src={"/navigate_before.svg"} />
          </div>
        </DivMobileHeaderBack> */}
        <DivMobileHeaderTitle>{t("horse_profile_title")}</DivMobileHeaderTitle>
        {/* <DivMobileHeaderBack></DivMobileHeaderBack> */}
      </DivMobileHeader>
      <Container>
        <Content>
          <BasicInfo type="mobile" {...props} />
          <MItemBottom>
            <LeftBtn style={props.totalRun >= 0 ? props.data?.horseFormRecord?.length > 0 ? { flexBasis: "35%" } : {width: "100%"} : {width: "100%"}} 
              onClick={() => handleSelectPerformance({}, "fullForm")}
              className={selectedTabM == "fullForm" ? "selected" : ""}
            >
              <p>{t("full_form")}</p>
            </LeftBtn>
            { props.totalRun >= 0 ? props.data?.horseFormRecord?.length > 0 ?
              <RightBtn
                onClick={() => handleSelectPerformance({}, "performance")}
                className={selectedTabM == "performance" ? "selected" : ""}
              >
                <p>{t("performance_by_distance")}</p>
              </RightBtn> : <></> : <></>
            }
          </MItemBottom>
          <Collapse in={selectedTabM === "fullForm"}> 
            {selectedTabM === "fullForm" ? (
              <FullFormM
                raceNo={props.raceNo}
                data={{ id: props.simulcastHorseId }}
                gearData={props.gearData}
                totalRun={props.totalRun}
              />
            ) : null}
          </Collapse>
          <Collapse in={selectedTabM === "performance"}>
            <RaceCardPerformance
              type="mobile"
              page="horseInfo"
              data={{ performanceStats: props?.data?.performanceStats }}
              horseName={props?.data?.name_en}
              raceCountry={props?.raceCountry}
              meetingDate={props?.meetingDate}
              meetingVenueCode={props?.meetingVenueCode}
              raceNo={props?.raceNo}
            />
          </Collapse>
        </Content>
      </Container>
    </>
  );
};
export default HorseProfile;
